import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  selector: 'inlite-primary-button',
  templateUrl: './primary-button.component.html',
  styleUrls: ['./primary-button.component.css'],
})
export class PrimaryButtonComponent {
  @Input() title: string;
  @Output() clickButton = new EventEmitter<any>();
  @Input() isLoading: boolean;

  onButtonClick(event): void {
    this.clickButton.emit(event);
  }
}
